import styled from "styled-components";
import theme from "src/styles/theme";

export const AddButtonStyle = `
  display : flex;
  gap : 1.5rem;
  align-items : center;
  justify-content : center;
  padding : 2.5rem 0;
`;

export const Title = styled.h2`
  color: ${theme.color.black700};
  text-align: center;
  font-size: 1.6rem;
  font-weight: 600;
`;
